<template>
    <div class="text-drop-down"
         @mouseleave="hover = false"
         @mouseover="hover = true">
        <div @click="toggleList()" class="text-btn">{{label}}</div>
        <div class="drop-down-list" v-if="showList">
            <div v-for="(item, key) in items"
                 :key="key"
                 :class="['drop-down-item', {'active': item.label === label}]"
                 @click="changeItem(item)"
            >
                {{item.text}}
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "text-drop-down",
        data() {
            return {
                showList: false,
                label: "text",
                hover: false,
                dataValue: "",
                dataAllValue: {},
                dataItems: [],
            }
        },
        props: {
            value: {
                type: [String, Number, Object],
                default: null,
            },
            items: {
                type: Array,
                required: true,
            }
        },
        mounted() {
            this.dataItems = this.items.slice();

            const item = this.items.find(x => x.value === this.value);
            if (item) {
                this.dataValue = item.value;
                this.dataAllValue = item;
                this.label = item.label;
            } else {
                this.dataValue = this.items[0].value;
                this.dataAllValue = this.items[0];
                this.label = this.items[0].label;
            }

            window.addEventListener("click", this.outside)
        },
        methods: {
            outside() {
                if (!this.hover) {
                    this.hideList();
                }
            },
            toggleList() {
                this.showList = !this.showList
            },
            changeItem(item) {
                this.label        = item.label;
                this.dataValue    = item.value;
                this.dataAllValue = item;
                this.hideList();
                this.$nextTick(() => {
                    this.$emit("change", item.value);
                })
            },
            hideList() {
                this.showList = false
            }
        },
        watch: {
            value(val) {
                if (val) {
                    let item = this.items.find(x => x.value === val)
                    if (item) {
                        this.label        = item.label;
                        this.dataValue    = item.value;
                        this.dataAllValue = item;
                    }
                }
            },
            dataValue(val) {
                this.$emit("input", val);
            },
            dataAllValue(val) {
                this.$emit("all-value", val);
            },
            items: {
                deep: true,
                handler(val) {
                    if (!this.value) {
                        this.dataItems = val.slice();
                        this.label = val[0].label;
                        this.dataValue = val[0].value;
                        this.dataAllValue = val[0];
                    } else {
                        let item = val.find(x => x.value === this.value);
                        this.dataItems = val.slice();
                        this.label = item.label;
                        this.dataValue = item.value;
                        this.dataAllValue = item;
                    }
                }
            }
        },
        beforeDestroy() {
            window.removeEventListener("click", this.outside);
        }
    }
</script>

<style scoped>
    .text-drop-down {
        position: relative;
        width: max-content;
    }
    .text-drop-down .text-btn {
        font-weight: 500;
        font-size: 13px;
        line-height: 15px;
        color: var(--white-color);
        cursor: pointer;
    }
    .text-drop-down .drop-down-list {
        min-width: 50px;
        max-height: 260px;
        position: absolute;
        top: 30px;
        right: calc(50% - 27px);
        border-radius: 4px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
        padding: 4px 0;
        background-color: var(--white-color);
        z-index: 11;
    }
    .text-drop-down .drop-down-list .drop-down-item {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--dark-1-color);
        padding: 4px 12px;
        transition: all .2s;
        cursor: pointer;
        white-space: nowrap;
    }
    .text-drop-down .drop-down-list .drop-down-item:hover,
    .text-drop-down .drop-down-list .drop-down-item.active {
        background-color: var(--primary-2-color);
    }
</style>
